import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { CabecalhoDoPainel, NivelAtual, } from '@/features/exploracao/Navegacao';
import { IconeCamadas } from '@/components/Icones';
import { useI18n } from '@/i18n/I18nProvider';
/**
 * Painel direito de exploração territorial.
 *
 * Mantém o estado de recolhimento local, e o estado de navegação (nível,
 * camada em exploração, feição selecionada) em provedores acima. Recolher
 * o painel **não descarta contexto algum**: ao reabrir, o usuário retorna
 * ao mesmo nível, com a mesma seleção e a mesma visibilidade das camadas.
 *
 * O mapa permanece montado em todo o ciclo. Um `ResizeObserver` sobre o
 * container do MapLibre (em `Mapa.tsx`) chama `map.resize()` em mudanças
 * efetivas de dimensão, incluindo as provocadas pelo recolhimento aqui.
 */
export function PainelDeExploracao() {
    const [recolhido, setRecolhido] = useState(false);
    const { t } = useI18n();
    const recolher = () => {
        setRecolhido(true);
    };
    const reabrir = () => {
        setRecolhido(false);
    };
    if (recolhido) {
        return (_jsxs("button", { type: "button", className: "painel-exploracao__reabrir", onClick: reabrir, "aria-label": t('exploracao.reabrirPainelNome'), title: t('exploracao.reabrirPainel'), children: [_jsx(IconeCamadas, {}), _jsx("span", { children: t('exploracao.titulo') })] }));
    }
    return (_jsxs("aside", { className: "painel-exploracao", "aria-label": t('exploracao.painel'), children: [_jsx(CabecalhoDoPainel, { recolhido: false, aoRecolher: recolher }), _jsx("div", { className: "painel-exploracao__corpo", children: _jsx(NivelAtual, {}) })] }));
}
